module.exports = __webpack_public_path__ + "static/img/img-home-co-01.90385e0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/imgs/img-home-co-01.png
// module id = Ic8I
// module chunks = 1